
import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQSection = () => {
  const faqs = [
    {
      question: "Wie schnell bekomme ich mein Video?",
      answer: "In der Regel ist Ihr fertiges Video innerhalb von 48 Stunden verfügbar. Bei komplexeren Projekten kann es etwas länger dauern, aber wir halten Sie stets über den Fortschritt auf dem Laufenden."
    },
    {
      question: "Was kostet ein KI-Video?",
      answer: "Die Preise für KI-Videos beginnen bei CHF 490 für ein Basis-Video. Je nach Komplexität, Länge und benötigten Anpassungen kann der Preis variieren. Kontaktieren Sie uns für ein individuelles Angebot."
    },
    {
      question: "Für welche Plattformen ist es optimiert?",
      answer: "Unsere Videos werden für alle gängigen Social-Media-Plattformen optimiert: Instagram (Feed, Reels, Stories), Facebook, TikTok, LinkedIn, YouTube Shorts und Pinterest. Wir liefern in den jeweils passenden Formaten und Spezifikationen."
    },
    {
      question: "Kann ich mein Branding einbauen?",
      answer: "Absolut! Wir integrieren Ihr Branding nahtlos in die Videos – von Farben und Logos bis hin zu Schriftarten und Ihrem individuellen Look & Feel. Dies ist ein wesentlicher Bestandteil unseres Services."
    },
    {
      question: "Wie viele Änderungen sind inbegriffen?",
      answer: "In jedem Paket sind zwei Revisionsrunden enthalten. So können wir sicherstellen, dass das Video genau Ihren Vorstellungen entspricht, bevor es finalisiert wird."
    },
    {
      question: "Habt ihr Erfahrung in meiner Branche?",
      answer: "Mit über 50 erfolgreichen Projekten haben wir Erfahrung in diversen Branchen – von E-Commerce und Gesundheitswesen bis hin zu Finanzen und Bildung. Unsere KI-Technologie kann sich schnell an die Anforderungen jeder Branche anpassen."
    }
  ];

  return (
    <section className="py-24 bg-[#0A0A0A] relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold font-future text-white mb-6">
            Häufig gestellte Fragen
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-purple-900 to-blue-900 mx-auto mb-6"></div>
          <p className="text-gray-300 max-w-2xl mx-auto">
            Alles, was Sie über unsere KI-Video-Services wissen müssen – 
            übersichtlich zusammengefasst.
          </p>
        </div>
        
        <div className="max-w-3xl mx-auto bg-[#111116]/80 backdrop-blur-sm border border-purple-900/20 rounded-xl p-6 md:p-8">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="border-b border-purple-900/20 last:border-0"
              >
                <AccordionTrigger className="text-white hover:text-purple-400 py-4 transition-all duration-300 text-left font-medium">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-400 pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
